import { EventEmitterInterface } from './emitter.interface';

export class EventEmitter implements EventEmitterInterface {
  public listeners: { [key: string]: Array<() => void> } = {};

  /**
   * @inheritDoc
   */
  public addListener(
    eventName: string,
    callbackFunction: (...args: Array<object | number | string | boolean>) => void
  ): void {
    // No listeners for this event name
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }

    // Register observer
    this.listeners[eventName].push(callbackFunction);
  }

  /**
   * @inheritDoc
   */
  public removeListener(
    eventName: string,
    callbackFunction?: (...args: Array<object | number | string | boolean>) => void
  ): void {
    // Has listeners for this event name
    if (!!this.listeners[eventName]) {
      // No callback
      if (callbackFunction === undefined) {
        // Remove all listeners for this event name
        this.listeners[eventName] = [];
      } else {
        // Remove specific observer
        const index = this.listeners[eventName].indexOf(callbackFunction);

        if (index > -1) {
          this.listeners[eventName].splice(index, 1);
        }
      }
    }
  }

  /**
   * @inheritDoc
   */
  public emit(eventName: string, ...args: Array<object | number | string | boolean>): void {
    // Has listeners for this event name
    if (!!this.listeners[eventName]) {
      // For each register observer
      this.listeners[eventName].forEach((callbackFunction) => callbackFunction.apply(null, args));
    }
  }

  /**
   * @inheritDoc
   */
  public getListeners(eventName: string): Array<() => void> {
    return this.listeners[eventName] || [];
  }
}
